import React, { useContext, useState, createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import en from "../../locale/en.json";
import he from "../../locale/he.json";

// Available languages
export const language_options = [
  { id: "he", text: "Hebrew" },
  { id: "en", text: "English" },
];

const dictionary_list = { he, en };

// Create the language context with default selected language
export const LanguageContext = createContext({
  language: language_options[0],
  dictionary: dictionary_list[language_options[0].id],
});

// Our context provider that will wrap the App
const LanguageProvider = (props) => {
  const lang = useSelector((state) => state.mode.language);

  const [language, setLanguage] = useState(
    language_options.find((option) => option.id === lang) || language_options[0]
  );
  const [dictionary, setDictionary] = useState(dictionary_list[language.id]);

  // Update language based on Redux `lang` value
  useEffect(() => {
    const selectedLanguage =
      language_options.find((option) => option.id === lang) ||
      language_options[0];
    setLanguage(selectedLanguage);
    setDictionary(dictionary_list[selectedLanguage.id]);
  }, [lang]);

  const provider = {
    language,
    setLanguage: (selected_language) => {
      setLanguage(selected_language);
      setDictionary(dictionary_list[selected_language.id]);
    },
    getTranslation: (text_id) => dictionary[text_id] || text_id,
  };

  return (
    <LanguageContext.Provider value={provider}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
